import React, {Ref, useState} from "react";
import {Box, InputAdornment, TextField} from "@mui/material";
import {useFormContext, Controller} from "react-hook-form";

interface FormInputTextFieldProps {
    InputProps?: any;
    helperText?: string;
    inputRef?: Ref<HTMLInputElement>;
    label: string;
    maxLength?: number;
    name: string;
    onChange?: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
    pattern?: RegExp;
    placeholder?: string;
    required?: boolean;
    size?: "small" | "medium";
    type?: string;
    sx?: any;
}

export const FormInputTextField: React.FC<FormInputTextFieldProps> = ({
                                                                          InputProps,
                                                                          helperText,
                                                                          inputRef,
                                                                          label,
                                                                          maxLength,
                                                                          name,
                                                                          onChange,
                                                                          pattern,
                                                                          placeholder = "",
                                                                          required = false,
                                                                          size = "medium",
                                                                          type = "text",
                                                                          sx = undefined
                                                                      }) => {
    const {control, formState: {errors}} = useFormContext();
    const [charCount, setCharCount] = useState(0);

    return (
        <Controller
            name={name}
            control={control}
            rules={{
                required: required ? helperText || "" : false,
                pattern: pattern ? {value: pattern, message: helperText || ""} : undefined,
            }}
            render={({field}) => (
                <TextField data-cypress={name + "Field"}
                           {...field}
                           id={name}
                           InputProps={{
                               ...InputProps,
                               inputRef,
                               endAdornment: maxLength ? (
                                   <InputAdornment position="end">
                                       <Box
                                           sx={{position: 'absolute', bottom: 0, right: 0, paddingRight: '10px', fontSize: '12px', color: 'gray'}}>
                                           {charCount}/{maxLength}
                                       </Box>
                                   </InputAdornment>
                               ) : null,
                           }}
                           error={!!errors[name]}
                           helperText={errors[name] ? helperText : ""}
                           label={label}
                           placeholder={placeholder}
                           required={required}
                           size={size}
                           type={type}
                           sx={sx}
                           fullWidth
                           onChange={(e) => {
                               field.onChange(e);
                               setCharCount(e.target.value.length);
                               if (onChange) onChange(e);
                           }}
                />
            )}
        />
    );
};
